import type { ShortcutId } from './shortcutCatalog';

export const NUDGE_GLOBAL_COOLDOWN_MS = 14_000;
export const NUDGE_PER_ACTION_COOLDOWN_MS = 8 * 60_000;
export const NUDGE_MAX_SHOWS_PER_ACTION = 2;
export const NUDGE_SESSION_GRACE_MS = 2_500;
export const NUDGE_VISIBLE_MS = 4_800;

export interface NudgeDecisionInput {
  nudgesEnabled: boolean;
  tutorialActive: boolean;
  dismissedActions: string[];
  keyboardUses: Record<string, number>;
  nudgeShows: Record<string, number>;
  lastNudgeAt: number;
  lastNudgeAtByAction: Record<string, number>;
  hasVisibleNudge: boolean;
  sessionStartedAt: number;
  now: number;
}

export type NudgeDecision = 'show' | 'skip';

let sessionStartedAt = Date.now();

export function getSessionStartedAt() {
  return sessionStartedAt;
}

/** Test helper — not used by the app. */
export function resetCoachSession(at = Date.now()) {
  sessionStartedAt = at;
}

/**
 * Pure policy: show a corner nudge only when the user just did a pointer
 * action that has a shortcut they have not used yet.
 */
export function evaluateNudge(input: NudgeDecisionInput, actionId: ShortcutId): NudgeDecision {
  if (!input.nudgesEnabled) return 'skip';
  if (input.tutorialActive) return 'skip';
  if (input.hasVisibleNudge) return 'skip';
  if (input.dismissedActions.includes(actionId)) return 'skip';
  if ((input.keyboardUses[actionId] ?? 0) > 0) return 'skip';
  if ((input.nudgeShows[actionId] ?? 0) >= NUDGE_MAX_SHOWS_PER_ACTION) return 'skip';
  if (input.now - input.sessionStartedAt < NUDGE_SESSION_GRACE_MS) return 'skip';
  if (input.lastNudgeAt > 0 && input.now - input.lastNudgeAt < NUDGE_GLOBAL_COOLDOWN_MS) return 'skip';
  const lastThis = input.lastNudgeAtByAction[actionId] ?? 0;
  if (lastThis > 0 && input.now - lastThis < NUDGE_PER_ACTION_COOLDOWN_MS) return 'skip';
  return 'show';
}
